<div class="content-layout fullwidth-standard-normal-scroll">
  <project-dashboard-header></project-dashboard-header>
  <div id="export-tab-to-pdf" class="content" cdkDropListGroup *ngIf="!newLayout">
    <div class="old flex flex-auto">
      <div
        class="flex flex-col w-1/3 border-right"
        *ngFor="let panelCol of panels; let i = index"
        (cdkDropListDropped)="dropped($event)"
        cdkDropList
        [cdkDropListData]="panelCol"
        cdkDragBoundary=".content"
      >
        <ng-container *ngFor="let panelDef of panelCol">
          <ng-container *ngIf="canDisplayPanel(panelDef) || editMode">
            <div cdkDrag [cdkDragData]="panelDef" [cdkDragDisabled]="!editMode" class="panel-section">
              <button
                *ngIf="editMode && termsheetUser()"
                (click)="showConditionalLogicModal(panelDef)"
                type="button"
                [matTooltip]="'Conditional Logic'"
                class="conditional-logic-panel-handler"
              >
                <mat-icon [svgIcon]="'code'"></mat-icon>
              </button>
              <button
                *ngIf="editMode"
                mat-icon-button
                [matTooltip]="'Delete me'"
                class="delete-panel-handler"
                (click)="onDeletePanelDef(panelDef)"
              >
                <mat-icon [svgIcon]="'delete'"></mat-icon>
              </button>
              <button *ngIf="editMode" mat-icon-button [matTooltip]="'Drag me'" cdkDragHandle class="panel-handler">
                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
              </button>
              <div id="panel-placeholder" *cdkDragPlaceholder></div>
              <div [ngClass]="{ 'panel-boundry': editMode }">
                <project-panel
                  #panels
                  [panelDef]="panelDef"
                  [project]="project"
                  [account]="account"
                  [data]="data"
                  (onEditPanelDef)="onEditPanelDef($event)"
                  (silentPanelDefUpdated)="onSilentPanelDefUpdated($event)"
                  (onUpdate)="onUpdate($event)"
                  (reloadAllPanelsOfTypes)="reloadAllPanelsOfTypes($event)"
                ></project-panel>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div id="export-tab-to-pdf" class="content-new" cdkDropListGroup *ngIf="newLayout">
    <div class="new flex flex-auto h-full">
      <gridster [options]="gridOptions">
        <ng-container *ngFor="let item of dashboardLayout">
          <ng-container *ngIf="lookupPanelDef(item.id) as panelDef">
            <gridster-item [item]="item" *ngIf="canDisplayPanel(panelDef) || editMode">
              <div class="panel-section">
                <button
                  *ngIf="editMode"
                  (click)="showConditionalLogicModal(panelDef)"
                  type="button"
                  [matTooltip]="'Conditional Logic'"
                  class="conditional-logic-panel-handler"
                >
                  <mat-icon [svgIcon]="'code'"></mat-icon>
                </button>
                <button
                  *ngIf="editMode"
                  mat-icon-button
                  [matTooltip]="'Delete me'"
                  class="delete-panel-handler"
                  (click)="removeItem($event, item)"
                >
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                </button>
                <button *ngIf="editMode" mat-icon-button [matTooltip]="'Drag me'" class="panel-handler drag-handler">
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </button>
                <div id="panel-placeholder" *cdkDragPlaceholder></div>
                <div class="height-100p" [ngClass]="{ 'panel-boundry': editMode }">
                  <project-panel
                    #panels
                    [panelDef]="panelDef"
                    [project]="project"
                    [account]="account"
                    [data]="data"
                    (onEditPanelDef)="onEditPanelDef($event)"
                    (silentPanelDefUpdated)="onSilentPanelDefUpdated($event)"
                    (onUpdate)="onUpdate($event)"
                    (reloadAllPanelsOfTypes)="reloadAllPanelsOfTypes($event)"
                  ></project-panel>
                </div>
              </div>
            </gridster-item>
          </ng-container>
        </ng-container>
      </gridster>
    </div>
  </div>
</div>
